<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Freddy the Pied Piper</span></p>
<p class="authorname"><span>Walter R. Brooks</span></p>
<p class="authorname"><span>Illustrated by Kurt Wiese</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_02.jpg"/></span></p>
<p class="publisher1"><span>The Overlook Press</span></p>
<p class="publisher1"><span>New York</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6dc24fcc